<template>
  <base-dialog
    :action="onAction"
    :action-name="'Charge'"
    :close="onClose"
    :title="'Charge customer for invoice'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <div class="title">Amount Due</div>
          <div class="subtitle-1" v-money="{ amount: invoice.amount_due, currency: invoice.currency}"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <customer-payment-source-select
            :customer="invoice.customer"
            @change-source="onChangeSource"
          />
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import CustomerPaymentSourceSelect from "../Common/CustomerPaymentSourceSelect"

export default {
  components: { CustomerPaymentSourceSelect, BaseDialog },
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      selectedSource: null
    }
  },
  methods:{
    ...mapActions([ 'payInvoice' ]),
    onChangeSource(source) {
      if (source) {
        this.selectedSource = source
      }
    },
    onClose(){
      this.$emit('close')
    },
    async onAction() {
      const payload = {
        id: this.invoice.id,
        payment_method: this.selectedSource
      }

      await this.payInvoice(payload)

      this.$emit('action', payload)
    }
  }
}
</script>
